import { AssessmentAction } from "../types/AssessmentAction";
import { AssessmentEntryEditAction } from "./AssessmentEntryEditAction";
import { AssessmentEntrySignOffAction } from "./AssessmentEntrySignOffAction";
import { AssessmentEntryExportAction } from "./AssessmentEntryExportAction";
import { AssessmentEntryUpdateAction } from "./AssessmentEntryUpdateAction";
import { AssessmentEntryModifySubmissionAction } from "./AssessmentEntryModifySubmissionAction";
import { FormEnums } from "../../../services/api/types/forms/enums/FormEnums";

export const DefaultAssessmentEntryActions: AssessmentAction[] = [
  {
    id: "export",
    component: AssessmentEntryExportAction,
  },
  {
    id: "edit",
    component: AssessmentEntryEditAction,
  },
  {
    id: "signoff",
    component: AssessmentEntrySignOffAction,
  },
  {
    id: "modifySubmission",
    component: AssessmentEntryModifySubmissionAction,
    condition: (entry) =>
      entry.form.tag !== FormEnums.ADMISSION_CHECKLIST &&
      entry.form.tag !== FormEnums.RESIDENT_PORTFOLIO,
  },
];

export const VersionedEntryActions: AssessmentAction[] = [
  {
    id: "export",
    component: AssessmentEntryExportAction,
  },
  {
    id: "update",
    component: AssessmentEntryUpdateAction,
  },
  {
    id: "signoff",
    component: AssessmentEntrySignOffAction,
  },
];
